/* File: assets/quick-order.js */
(function(){
  window.initQuickOrder = initQuickOrder;
  window.UPNDOWN_API_BASE = 'https://upndownco.tunnel.algomative.com';

  async function initQuickOrder(rootEl, { variants, meta, printingConfig, fetchConfig }) {
    if (!rootEl) throw new Error('quickOrderApp mount element not found');

    const cfg = printingConfig || (fetchConfig ? await fetchConfig() : null);
    if (!cfg) throw new Error('No printing config passed to initQuickOrder');

    const COLOR_META = readJSON('qo-color-meta') || [];
    const SIZE_META  = readJSON('qo-size-meta')  || [];
    const MEDIA_RAW  = readJSON('qo-media')      || [];

    const moneyFormat = meta.money_format || "${{amount}}";
    const colorIndex  = Number(meta.color_index ?? -1);
    const sizeIndex   = Number(meta.size_index  ?? -1);

    const globalApiBase = (typeof window !== 'undefined' && window.UPNDOWN_API_BASE) ? String(window.UPNDOWN_API_BASE) : '';
    const rawApiBase = (meta.api_base || globalApiBase || '').toString();
    const API_BASE = rawApiBase.replace(/\/+$/, '');
    const resolveEndpoint = (path, fallback = '') => {
      const target = path || fallback;
      if (!target) return ''; // caller must handle
      if (/^https?:\/\//i.test(target)) return target;
      if (!API_BASE) return target;
      return `${API_BASE}${target.startsWith('/') ? target : `/${target}`}`;
    };

    // DOM helpers scoped to root element
    const $  = (sel, el = rootEl) => el.querySelector(sel);
    const $$ = (sel, el = rootEl) => Array.from(el.querySelectorAll(sel));

    function readJSON(id){
      const n = document.getElementById(id);
      if (!n) return null;
      try { return JSON.parse(n.textContent); } catch { return null; }
    }

    const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
    const clamp01 = (n) => clamp(Number(n) || 0, 0, 1);
    const isFiniteNumber = (v) => typeof v === 'number' && Number.isFinite(v);
    const baseScaleFor = (px, baseWidth, baseHeight) => {
      if (!px || !baseWidth || !baseHeight) return 1;
      return Math.min(px.width / baseWidth, px.height / baseHeight);
    };
    const hydrateArtworkState = (rel, px, defaultScale) => {
      const legacyScaleX = (isFiniteNumber(rel?.scaleX) && defaultScale) ? rel.scaleX / defaultScale : null;
      const legacyScaleY = (isFiniteNumber(rel?.scaleY) && defaultScale) ? rel.scaleY / defaultScale : null;

      const multiplierX = isFiniteNumber(rel?.scaleMultiplierX) ? rel.scaleMultiplierX
        : (legacyScaleX != null ? legacyScaleX : null);
      const multiplierY = isFiniteNumber(rel?.scaleMultiplierY) ? rel.scaleMultiplierY
        : (legacyScaleY != null ? legacyScaleY : null);

      let centerX = isFiniteNumber(rel?.centerX) ? rel.centerX : null;
      if (centerX == null && isFiniteNumber(rel?.relX) && isFiniteNumber(rel?.relWidth)) {
        centerX = rel.relX + rel.relWidth / 2;
      }
      let centerY = isFiniteNumber(rel?.centerY) ? rel.centerY : null;
      if (centerY == null && isFiniteNumber(rel?.relY) && isFiniteNumber(rel?.relHeight)) {
        centerY = rel.relY + rel.relHeight / 2;
      }

      return {
        multiplierX: isFiniteNumber(multiplierX) ? multiplierX : null,
        multiplierY: isFiniteNumber(multiplierY) ? multiplierY : null,
        centerX: isFiniteNumber(centerX) ? centerX : 0.5,
        centerY: isFiniteNumber(centerY) ? centerY : 0.5,
        rotation: isFiniteNumber(rel?.rotation) ? rel.rotation : 0
      };
    };
    const persistArtworkState = (upload, node, px, defaultScale) => {
      if (!upload || !node || !px) return;
      const baseWidth = node.getAttr('_baseWidth') || node.width();
      const baseHeight = node.getAttr('_baseHeight') || node.height();
      const scaleX = node.scaleX();
      const scaleY = node.scaleY();
      const centerX = px.width ? (node.x() - px.x) / px.width : 0.5;
      const centerY = px.height ? (node.y() - px.y) / px.height : 0.5;
      const rect = node.getClientRect();

      upload.konva = {
        version: 1,
        centerX,
        centerY,
        scaleMultiplierX: defaultScale ? scaleX / defaultScale : 1,
        scaleMultiplierY: defaultScale ? scaleY / defaultScale : 1,
        rotation: node.rotation(),
        baseWidth,
        baseHeight,
        relWidth: px.width ? rect.width / px.width : null,
        relHeight: px.height ? rect.height / px.height : null,
        relX: px.width ? (rect.x - px.x) / px.width : null,
        relY: px.height ? (rect.y - px.y) / px.height : null,
        // Legacy keys kept so older data continues to work
        scaleX,
        scaleY
      };
    };
    const normalize = (str) => (str || '').toString().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
    const addDays = (date, days) => {
      const next = new Date(date);
      next.setDate(next.getDate() + Number(days || 0));
      return next;
    };
    const formatDeliveryDate = (date) => {
      return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' }).format(date);
    };
    // const formatMoney = (cents) => {
    //   const value = (cents / 100).toFixed(2);
    //   const out = moneyFormat.replace(/\$\{\{\s*amount\s*\}\}|\{\{\s*amount\s*\}\}/g, value);
    //   return out || `$${value}`;
    // };
    function formatMoney(cents, format) {
      if (typeof cents !== 'number') { cents = Number( cents ); }
      cents = (cents / 100);
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat || "${{amount}}");

      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, '');
          decimal   = defaultOption(decimal, '.');

          if (isNaN(number) || number === null) { return "0.00"; }

          number = (number).toFixed(precision);

          var parts   = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents   = parts[1] ? (decimal + parts[1]) : '';

          return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }

      const o = {
          symbol: formatString.replace(placeholderRegex, ''),
          amount_with_symbol: formatString.replace(placeholderRegex, value),
          amount: value
      };

      return o.amount_with_symbol;
    }
    const colorFromName = (str) => {
      let h = 0; for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
      return `hsl(${h % 360} 30% 60%)`;
    };

    const sectionEl = rootEl.closest('[data-section]');
    const sectionId = sectionEl ? sectionEl.dataset.section : '';
    const mediaGallery = sectionEl ? sectionEl.querySelector('media-gallery') : null;

    const MEDIA_LOOKUP = (() => {
      const map = Object.create(null);
      MEDIA_RAW.forEach(entry => {
        if (!entry || !entry.color || !entry.side) return;
        const ck = normalize(entry.color);
        const sk = normalize(entry.side);
        if (!map[ck]) map[ck] = Object.create(null);
        map[ck][sk] = entry;
      });
      return map;
    })();

    const colorMetaByLabel = (() => {
      const map = Object.create(null);
      COLOR_META.forEach(c => {
        if (!c || !c.label) return;
        map[c.label.trim().toLowerCase()] = { label: c.label, hex: c.color || null, image: c.image || null };
      });
      return map;
    })();

    const sizeOrder = (SIZE_META.length
      ? SIZE_META.map(s => (s && s.label) ? String(s.label) : '').filter(Boolean)
      : Array.from(new Set(variants.map(v => sizeIndex >= 0 ? (v.options[sizeIndex] || 'OS') : 'OS')))
    );

    const COLORS = {};
    variants.forEach(v => {
      const color = colorIndex >= 0 ? (v.options[colorIndex] || 'Default') : 'Default';
      const size  = sizeIndex  >= 0 ? (v.options[sizeIndex]  || 'OS')      : 'OS';
      if (!COLORS[color]) COLORS[color] = { image: v.image || null, sizes: [] };
      COLORS[color].sizes.push({ size, variantId: v.id, price: v.price, compare: v.compare_at_price || v.price });
      if (!COLORS[color].image) {
        const cm = colorMetaByLabel[color.trim().toLowerCase()];
        if (cm && cm.image) COLORS[color].image = cm.image;
      }
    });

    const criteriaList = Array.isArray(cfg.criteria) ? cfg.criteria.map((criteriaItem) => {
      const cid = String(criteriaItem.id ?? criteriaItem._id ?? '');
      return {
        ...criteriaItem,
        id: cid,
        volume_discounts: Array.isArray(criteriaItem.volume_discounts) ? criteriaItem.volume_discounts : [],
        printing_methods: (criteriaItem.printing_methods || []).map(method => ({
          ...method,
          criteria_id: cid
        }))
      };
    }) : [];

    const criteriaById = new Map(criteriaList.map(c => [c.id, c]));

    let methods = criteriaList.flatMap(c => c.printing_methods || []);
    if (!methods.length && Array.isArray(cfg.printing_methods)) {
      methods = cfg.printing_methods.map(method => ({
        ...method,
        criteria_id: method.criteria_id ? String(method.criteria_id) : null
      }));
    }
    cfg.printing_methods = methods;

    const methodById = new Map();
    const sideById   = new Map();
    methods.forEach(m => {
      const method = {
        ...m,
        criteriaId: m.criteria_id ? String(m.criteria_id) : null,
        min_order_qty: m.min_order_qty != null && m.min_order_qty !== '' ? Number(m.min_order_qty) : null,
      };
      methodById.set(method.id, method);
      (method.sides || []).forEach(s => {
        const side = {
          ...s,
          methodId: method.id,
          criteriaId: method.criteriaId,
        };
        sideById.set(side.id, side);
      });
    });

    const State = {
      selectedColor: Object.keys(COLORS)[0] || null,
      selectedMethodId: methods[0]?.id ?? null,
      activeCriteriaId: methods[0]?.criteriaId ?? (criteriaList[0]?.id ?? null),
      selectedSides: new Set(),
      activeSideId: null,
      uploads: {},
      rows: []
    };

    const uploadLibrary = {
      recent: [],
      past: [],
      requiresAuth: false,
      customerChecked: false,
      recentLoading: false,
      customerLoading: false
    };

    const getTotalQty = () => State.rows.reduce((sum, row) => sum + Object.values(row.qtyBySize).reduce((a, b) => a + (parseInt(b, 10) || 0), 0), 0);
    const getActiveCriteria = () => {
      const method = methodById.get(State.selectedMethodId);
      const criteriaId = State.activeCriteriaId || method?.criteriaId;
      return criteriaId ? criteriaById.get(String(criteriaId)) || null : null;
    };

    const ALLOW_ARTWORK_OVERFLOW = true;
    const INITIAL_ARTWORK_SCALE = 0.82;

    let artworkLibraryModal = null;
    let artworkLibraryBody = null;
    let artworkLibrarySideId = null;
    let artworkLibraryFallbackInput = null;
    let latestFallbackInput = null;

    const uploader = {
      instance: null,
      sideId: null,
      endpoints: {
        upload: resolveEndpoint(meta.upload_endpoint, '/api/customizer/uploads'),
        recent: resolveEndpoint(meta.recent_uploads_endpoint, '/api/customizer/uploads'),
        customer: resolveEndpoint(meta.customer_artworks_endpoint, '/api/customizer/customer-artworks')
      },
      companionUrl: cfg.uppy_companion_url || meta.uppy_companion_url || 'https://companion.uppy.io'
    };

    if (State.selectedColor) {
      const qtyBySize = {};
      sizeOrder.forEach(sz => qtyBySize[sz] = 0);
      State.rows.push({ color: State.selectedColor, qtyBySize });
    }

    rootEl.innerHTML = `
      <div class="qo">
        <section class="qo-step qo-step--colours">
          <div class="qo-step__header">
            <h3 class="qo-step__title">STEP 1. SELECT COLOURS:</h3>
            <span class="qo-step__value qo-color-current">—</span>
          </div>
          <div class="qo-swatches" role="radiogroup" aria-label="Select colour"></div>
        </section>

        <section class="qo-step qo-step--methods">
          <div class="qo-step__header">
            <h3 class="qo-step__title">STEP 2. SELECT PRINT AREAS</h3>
            <span class="qo-step__value qo-side-current">—</span>
          </div>
          <div class="ps_mb_2">
            Not sure which printing technique to choose?
            <a href="#" x-on:click.prevent="openDecorationMethodsHelp()" class="ps_helper_link">Learn more</a>
          </div>
          <div class="qo-methods" role="list"></div>
          <div class="qo-sides" role="group" aria-label="Select sides"></div>
          <div class="qo-restrictions qo-alert qo-alert--info is-hidden" aria-live="polite"></div>
        </section>

        <section class="qo-post-sides">
          <div class="qo-uploads">
            <div class="qo-uploads__heading">
              <strong>Upload Artwork File</strong>
              <span class="qo-required">(Required)</span>
            </div>
            <span class="qo-uploads__description">Max. 50MB. Preferred file types: png, svg, jpg, heic, tiff.</span>
            <div class="qo-uploads__list"></div>
          </div>

          <h3 class="qo-step__title">STEP 3. SELECT SIZES AND QUANTITIES</h3>
          <div class="qo-bundle">
            <div class="qo-bundle__copy">
                <h4>Unlock Big Savings with Bundle Pricing on this product</h4>
                <p>The more you buy, the more you save.</p>
            </div>
            <div class="qo-bundle__table"></div>
          </div>

          <button class="button button--tertiary qo-btn qo-add-colour" type="button">+ Add Another Colour ▾</button>

          <div class="qo-rows"></div>


          <div class="qo-summary">
            <div class="qo-summary__totals is-hidden">
              <div>
                <div class="qo-total">$0.00</div>
                <div class="qo-compare"></div>
              </div>
              <div>
                <div class="qo-each"></div>
                <div class="qo-items"></div>
              </div>
            </div>
            <button id="qo_cart_button" class="button button--primary qo-btn qo-btn--primary" data-action="add-to-cart" disabled>Add to Cart</button>
            <span class="qo_add_to_cart_disclaimer_text"><span>Order today and we'll print and ship your order by</span>&nbsp;<strong></strong></span>
            </div>
        </section>
      </div>
    `;

    if (!document.getElementById('qo-inline-modal-style')) {
      const style = document.createElement('style');
      style.id = 'qo-inline-modal-style';
      style.textContent = `
      .qo-modal__backdrop{position:fixed;inset:0;background:rgba(0,0,0,.58);display:flex;align-items:center;justify-content:center;z-index:99999}
      .qo-modal{width:min(880px,94vw);max-height:88vh;overflow:auto;background:#fff;border-radius:0px;box-shadow:0 18px 40px rgba(15,23,42,.18);}
      .qo-modal header{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #eee;font-weight:700;letter-spacing:.02em;text-transform:uppercase;}
      .qo-modal header button{border:1px solid #e5e7eb;background:#fff;width:32px;height:32px;border-radius:999px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:18px;line-height:0;transition:transform .12s ease,background .12s ease;}
      .qo-modal header button:hover{background:#f3f4f6;transform:rotate(90deg);}
      .qo-modal .body{padding:20px;}
      .qo-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:16px;}
      .qo-color-card{border:1px solid #e5e7eb;border-radius:12px;padding:12px;text-align:center;background:#fff;cursor:pointer;transition:box-shadow .15s ease,border-color .15s ease,transform .06s ease;}
      .qo-color-card:hover{box-shadow:0 15px 30px rgba(17,24,39,.08);border-color:#d1d5db;}
      .qo-color-chip{width:100%;aspect-ratio:4/3;border-radius:8px;border:1px solid #ddd;background:#f3f4f6;}
      .qo-uploader{border:2px dashed #d9d1c6;border-radius:16px;padding:24px;background:#faf7f3;text-align:center;display:flex;flex-direction:column;gap:10px;align-items:center;}
      .qo-uploader-buttons{display:flex;flex-wrap:wrap;gap:10px;justify-content:center;}
      .qo-uploader-buttons button{border:1px solid #d1d5db;background:#fff;border-radius:10px;padding:10px 14px;cursor:pointer;font-weight:600;}
      .qo-modal--decor-help .qo-modal-body{padding:0;}
      .ps_decoration_method_help{padding:32px 0px 40px;max-width:720px;margin:0 auto;}
      .ps_decoration_method_help_tabs{display:flex;align-items:flex-end;gap:32px;border-bottom:1px solid #d1d5db;margin:0 0 28px;padding:0 4px;}
      .ps_decoration_method_help_tab{position: relative;border: 0;background: none;padding: 12px 0px 16px;font-weight: 500;font-size: 2.5rem;letter-spacing: .08em;text-transform: uppercase;color: #6b7280;cursor: pointer;width: 100%;transition:color .18s ease;}
      .ps_decoration_method_help_tab::after{content:'';position:absolute;left:0;bottom:-1px;width:100%;height:2px;background:#111827;opacity:0;transform:scaleX(.4);transform-origin:50% 50%;transition:opacity .18s ease,transform .18s ease;}
      .ps_decoration_method_help_tab:hover{color:#111827;}
      .ps_decoration_method_help_tab:focus-visible{outline:2px solid #111827;outline-offset:4px;}
      .ps_decoration_method_help_tab.active{color:#111827;}
      .ps_decoration_method_help_tab.active::after{opacity:1;transform:scaleX(1);}
      .ps_decoration_method_help_contents{margin-top:0;}
      .ps_decoration_method_help_item{display:none;}
      .ps_decoration_method_help_item.is-active{display:block;}
      .ps_decoration_method_help .decoration-content{display:flex;flex-direction:column;gap:18px;}
      .ps_decoration_method_help .decoration-content h2{margin:0;font-size:3.5rem;font-weight:500;line-height:1.35;color:#111827;}
      .ps_decoration_method_help .decoration-content p{margin:0;color:#4b5563;line-height:1.7;font-size: medium;}
      .ps_decoration_method_help .decoration-content ul{margin:0;padding-left:20px;color:#4b5563;line-height:1.7;}
      .ps_decoration_method_help .decoration-content li+li{margin-top:6px;}
      .ps_decoration_method_help .decoration-image-wrapper{border-radius:12px;overflow:hidden;}
      .ps_decoration_method_help .decoration-image-wrapper img{width:100%;display:block;}
      .ps_decoration_method_help .decoration-list{list-style:disc;}
      `;
      document.head.appendChild(style);
    }

    const refs = {
      colorLabel: $('.qo-color-current'),
      sideLabel:  $('.qo-side-current'),
      swatches:   $('.qo-swatches'),
      methods:    $('.qo-methods'),
      sides:      $('.qo-sides'),
      restrictions: $('.qo-restrictions'),
      addColor:   $('.qo-add-colour'),
      uploadList: $('.qo-uploads__list'),
      postSides:  $('.qo-post-sides'),
      bundleTbl:  $('.qo-bundle__table'),
      rowsWrap:   $('.qo-rows'),
      total:      $('.qo-total'),
      compare:    $('.qo-compare'),
      each:       $('.qo-each'),
      items:      $('.qo-items'),
      totalsWrap: $('.qo-summary__totals'),
      addToCart:  $('[data-action="add-to-cart"]'),
      helpLink:   $('.ps_helper_link')
    };
    refs.validation = $('.qo-validation');

    function updateShippingEstimate(){
      const target = rootEl.querySelector('.qo_add_to_cart_disclaimer_text');
      if (!target) return;
      const prefix = "Order today and we'll print and ship your order by";
      const startDate = addDays(new Date(), 10);
      const endDate = addDays(startDate, 4);
      const rangeText = `${formatDeliveryDate(startDate)} - ${formatDeliveryDate(endDate)}`;
      target.innerHTML = `<span>${prefix}</span>&nbsp;<strong>${rangeText}</strong>`;
    }

    updateShippingEstimate();

    if (refs.helpLink) {
      refs.helpLink.addEventListener('click', (event) => {
        event.preventDefault();
        openDecorationMethodsHelp();
      });
    }

    const overlay = createOverlay();
    const methodCards = new Map();
    const sideCards = new Map();
    let stage = null;
    let guideLayer = null;
    let artworkLayer = null;
    let guideRect = null;
    let gridGroup = null;
    let gridHorizontal = null;
    let gridVertical = null;
    let dimensionText = null;
    let transformer = null;
    let currentGuidePx = null;
    let currentArtworkNode = null;
    let persistCurrentArtwork = null;
    let konvaReady = false;
    let renderToken = 0;
    let guidesVisible = true;
    const placeholderButton = overlay.querySelector('.qo-stage__placeholder');
    const removeArtworkButton = overlay.querySelector('.qo-stage__remove');

    function createOverlay(){
      const wrapper = document.createElement('div');
      wrapper.className = 'qo-stage';
      wrapper.innerHTML = `
        <div class="qo-stage__canvas"></div>
        <button type="button" class="qo-stage__placeholder">Upload Artwork</button>
        <button type="button" class="qo-stage__remove" aria-label="Remove artwork">×</button>
      `;
      return wrapper;
    }

    placeholderButton.addEventListener('click', () => {
      if (!State.activeSideId) {
        showToast('Select a print area before uploading artwork');
        return;
      }
      openArtworkLibrary(State.activeSideId, { fallbackInput: latestFallbackInput });
    });

    removeArtworkButton.addEventListener('click', () => {
      if (!State.activeSideId) return;
      removeArtwork(State.activeSideId);
    });

    function clampBoxWithinArea(box){
      if (!currentGuidePx || !currentGuidePx.px) return box;
      const area = currentGuidePx.px;
      const left = Math.min(box.x, box.x + box.width);
      const right = Math.max(box.x, box.x + box.width);
      const top = Math.min(box.y, box.y + box.height);
      const bottom = Math.max(box.y, box.y + box.height);
      const width = right - left;
      const height = bottom - top;
      const x = Math.min(Math.max(left, area.x), area.x + area.width - width);
      const y = Math.min(Math.max(top, area.y), area.y + area.height - height);
      const signX = box.width < 0 ? -1 : 1;
      const signY = box.height < 0 ? -1 : 1;
      return { x, y, width: signX * width, height: signY * height };
    }

    function boundBoxWithinArea(oldBox, newBox){
      if (!currentGuidePx || !currentGuidePx.px) return newBox;
      const area = currentGuidePx.px;
      const left = Math.min(newBox.x, newBox.x + newBox.width);
      const right = Math.max(newBox.x, newBox.x + newBox.width);
      const top = Math.min(newBox.y, newBox.y + newBox.height);
      const bottom = Math.max(newBox.y, newBox.y + newBox.height);
      if (left < area.x || top < area.y || right > area.x + area.width || bottom > area.y + area.height) {
        return oldBox;
      }
      return newBox;
    }

    function clampPointWithinArea(pos, node){
      if (!currentGuidePx || !currentGuidePx.px || !node) return pos;
      const area = currentGuidePx.px;
      const rect = node.getClientRect();
      const dx = pos.x - node.x();
      const dy = pos.y - node.y();
      let nextRect = {
        x: rect.x + dx,
        y: rect.y + dy,
        width: rect.width,
        height: rect.height
      };
      let x = pos.x;
      let y = pos.y;
      if (nextRect.x < area.x) x += area.x - nextRect.x;
      if (nextRect.y < area.y) y += area.y - nextRect.y;
      if (nextRect.x + nextRect.width > area.x + area.width) x -= (nextRect.x + nextRect.width) - (area.x + area.width);
      if (nextRect.y + nextRect.height > area.y + area.height) y -= (nextRect.y + nextRect.height) - (area.y + area.height);
      return { x, y };
    }

    function ensureNodeWithinArea(node){
      if (!currentGuidePx || !currentGuidePx.px || !node) return;
      const area = currentGuidePx.px;
      let rect = node.getClientRect();
      if (rect.width > area.width || rect.height > area.height) {
        const scaleDown = Math.min(area.width / rect.width, area.height / rect.height);
        const signX = Math.sign(node.scaleX()) || 1;
        const signY = Math.sign(node.scaleY()) || 1;
        node.scaleX(node.scaleX() * scaleDown);
        node.scaleY(node.scaleY() * scaleDown);
        rect = node.getClientRect();
      }
      let dx = 0;
      let dy = 0;
      if (rect.x < area.x) dx = area.x - rect.x;
      if (rect.y < area.y) dy = area.y - rect.y;
      if (rect.x + rect.width > area.x + area.width) dx -= (rect.x + rect.width) - (area.x + area.width);
      if (rect.y + rect.height > area.y + area.height) dy -= (rect.y + rect.height) - (area.y + area.height);
      if (dx || dy) {
        node.position({ x: node.x() + dx, y: node.y() + dy });
      }
    }

    function waitForKonva(){
      if (window.Konva) return Promise.resolve(window.Konva);
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const timer = setInterval(() => {
          if (window.Konva) {
            clearInterval(timer);
            resolve(window.Konva);
          } else if (Date.now() - start > 7000) {
            clearInterval(timer);
            reject(new Error('Konva timeout'));
          }
        }, 30);
      });
    }

    async function setupStage(){
      if (konvaReady) {
        resizeStage();
        return;
      }
      try {
        await waitForKonva();
      } catch (err) {
        console.warn('[quickOrder] Konva failed to load', err);
        return;
      }
      const mount = overlay.querySelector('.qo-stage__canvas');
      const rect = mount.getBoundingClientRect();
      stage = new Konva.Stage({ container: mount, width: rect.width || 600, height: rect.height || 720 });
      guideLayer = new Konva.Layer();
      artworkLayer = new Konva.Layer();
      stage.add(guideLayer);
      stage.add(artworkLayer);
      guideRect = new Konva.Rect({
        stroke: '#f3c98b',
        strokeWidth: 2,
        dash: [8, 6],
        cornerRadius: 18,
        listening: false
      });
      guideLayer.add(guideRect);

      gridGroup = new Konva.Group({ listening: false, visible: false });
      gridHorizontal = new Konva.Line({
        stroke: '#f59e0b',
        strokeWidth: 1,
        dash: [6, 6],
        listening: false
      });
      gridVertical = new Konva.Line({
        stroke: '#f59e0b',
        strokeWidth: 1,
        dash: [6, 6],
        listening: false
      });
      gridGroup.add(gridHorizontal);
      gridGroup.add(gridVertical);
      guideLayer.add(gridGroup);
      dimensionText = new Konva.Text({
        text: '',
        fontSize: 16,
        fontStyle: '700',
        fill: '#111827',
        listening: false,
        shadowColor: 'rgba(255,255,255,0.85)',
        shadowBlur: 18,
        shadowOpacity: 1,
        stroke: '#ffffff',
        strokeWidth: 0.4
      });
      guideLayer.add(dimensionText);
      const transformerConfig = {
        rotateEnabled: true,
        flipEnabled: false,
        keepRatio: true,
        enabledAnchors: ['top-left','top-right','bottom-left','bottom-right'],
        anchorSize: 10,
        borderStroke: '#f97316',
        anchorStroke: '#f97316',
        anchorFill: '#ffffff'
      };
      if (!ALLOW_ARTWORK_OVERFLOW) {
        transformerConfig.boundBoxFunc = boundBoxWithinArea;
      }
      transformer = new Konva.Transformer(transformerConfig);
      artworkLayer.add(transformer);
      konvaReady = true;
      window.addEventListener('resize', debounce(resizeStage, 160));
    }

    function resizeStage(){
      if (!stage) return;
      const mount = overlay.querySelector('.qo-stage__canvas');
      const rect = mount.getBoundingClientRect();
      stage.size({ width: rect.width || 600, height: rect.height || 720 });
      drawGuide();
      renderArtwork();
    }

    function galleryActiveMedia(){
      if (!mediaGallery) return null;
      const viewer = mediaGallery.elements?.viewer || mediaGallery.querySelector('[id^="GalleryViewer"]');
      return viewer ? viewer.querySelector('.product__media-item.is-active') : null;
    }

    function attachOverlay(){
      if (!State.selectedSides.size) {
        if (overlay.parentElement) overlay.remove();
        return;
      }
      const active = galleryActiveMedia();
      if (!active) return;
      if (overlay.parentElement !== active) {
        active.style.position = 'relative';
        active.appendChild(overlay);
      }
      setupStage();
      drawGuide();
      renderArtwork();
    }

    function debounce(fn, wait = 120){
      let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
    }

    function mediaFor(colorName, sideName){
      const ck = normalize(colorName);
      const sk = normalize(sideName);
      return MEDIA_LOOKUP[ck]?.[sk] || null;
    }

    function colorPreview(colorName){
      const ck = normalize(colorName);
      const map = MEDIA_LOOKUP[ck];
      if (map) {
        const first = Object.values(map)[0];
        if (first?.src) return first.src;
      }
      return COLORS[colorName]?.image || null;
    }

    function syncGallery(){
      if (!mediaGallery || !sectionId) return;
      const side = getActiveSide();
      const color = State.selectedColor;
      if (!side || !color) return;
      let entry = mediaFor(color, side.name);
      if (!entry) {
        const altMap = MEDIA_LOOKUP[normalize(color)];
        if (altMap) {
          entry = Object.values(altMap).find(Boolean) || null;
        }
      }
      const mediaId = entry?.media_id;
      if (!mediaId) return;
      const fullId = `${sectionId}-${mediaId}`;
      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(fullId, false);
      } else {
        const viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
        const target = viewer?.querySelector(`[data-media-id="${fullId}"]`);
        if (target) {
          viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
          target.classList.add('is-active');
        }
      }
      window.setTimeout(attachOverlay, 60);
    }

    function getSelectedSides(){
      return Array.from(State.selectedSides).map(id => sideById.get(id)).filter(Boolean);
    }

    function getActiveSide(){
      return State.activeSideId != null ? sideById.get(State.activeSideId) || null : null;
    }

    function setActiveSide(sideId){
      if (sideId == null) {
        State.activeSideId = null;
        return;
      }
      if (State.selectedSides.has(sideId)) {
        State.activeSideId = sideId;
      }
    }

    function syncRowsWithSelectedColor(){
      if (!State.selectedColor) return;
      if (State.rows.length === 0) {
        const qtyBySize = {};
        sizeOrder.forEach(sz => qtyBySize[sz] = 0);
        State.rows.push({ color: State.selectedColor, qtyBySize });
      } else if (State.rows.length === 1 && State.rows[0].color !== State.selectedColor) {
        const qtyBySize = {};
        sizeOrder.forEach(sz => qtyBySize[sz] = 0);
        State.rows[0] = { color: State.selectedColor, qtyBySize };
      }
    }

    function renderSwatches(){
      syncRowsWithSelectedColor();
      refs.swatches.innerHTML = '';
      Object.keys(COLORS).forEach(name => {
        const cm = colorMetaByLabel[name.trim().toLowerCase()];
        const swatchColor = cm?.hex || colorFromName(name);
        const btn = document.createElement('button');
        const spn = document.createElement('span');
        btn.appendChild(spn);
        btn.type = 'button';
        btn.className = 'qo-swatch';
        spn.dataset.color = name;
        spn.style.setProperty('background', swatchColor);
        btn.setAttribute('role','radio');
        btn.setAttribute('aria-checked', String(State.selectedColor === name));
        btn.title = name;
        btn.addEventListener('click', () => {
          console.log("sdsd");
          if (State.selectedColor === name) return;
          State.selectedColor = name;
          refs.colorLabel.textContent = name;
          window.dispatchEvent(new CustomEvent('quickorder:color-change', { detail:{ color: name, image: colorPreview(name) }}));
          renderSwatches();
          updateSideCards();
          renderRows();
          renderUploads();
          priceRecalc();
          refreshValidation();
          syncGallery();
        });
        refs.swatches.appendChild(btn);
      });
      refs.colorLabel.textContent = State.selectedColor || '—';
    }

    function buildMethods(){
      if (!refs.methods) return;
      refs.methods.innerHTML = '';
      methodCards.clear();
      const totalQty = getTotalQty();
      methods.forEach(method => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'qo-method';
        card.dataset.methodId = String(method.id);
        const minText = method.min_order_qty ? `<div class="qo-method__note">Min ${method.min_order_qty} pcs</div>` : '';
        card.innerHTML = `
          <div class="qo-method__image">${method.image ? `<img src="${method.image}" alt="${method.name}">` : ''}</div>
          <div class="qo-method__content">
            <div class="qo-method__name">${method.name}</div>
            <div class="qo-method__desc">${method.description || ''}</div>
            ${minText}
          </div>
        `;
        card.addEventListener('click', () => selectMethod(method.id, { user: true }));
        methodCards.set(method.id, card);
        refs.methods.appendChild(card);
      });
      updateMethodCards();
    }

    function updateMethodCards(){
      const totalQty = getTotalQty();
      methodCards.forEach((card, id) => {
        const active = id === State.selectedMethodId;
        const method = methodById.get(id);
        const minQty = method?.min_order_qty ? Number(method.min_order_qty) : 0;
        const disabled = minQty > 0 && totalQty < minQty;
        card.setAttribute('aria-pressed', String(active));
        card.classList.toggle('is-active', active);
        card.classList.toggle('is-disabled', disabled);
        card.disabled = disabled;
        card.setAttribute('aria-disabled', String(disabled));
      });
    }

    function selectMethod(methodId, { user = false } = {}){
      const method = methodById.get(methodId);
      if (!method) return;
      const minQty = method.min_order_qty ? Number(method.min_order_qty) : 0;
      if (minQty > 0 && getTotalQty() < minQty) {
        showToast(`${method.name} requires at least ${minQty} pieces`, 'warning');
        return;
      }
      if (State.selectedMethodId === methodId) {
        if (!State.selectedSides.size) {
          buildSides(true);
          renderUploads();
          refreshValidation();
        }
        return;
      }
      State.selectedMethodId = methodId;
      State.activeCriteriaId = method.criteriaId || State.activeCriteriaId;
      State.selectedSides.clear();
      State.activeSideId = null;
      updateMethodCards();
      buildSides(true);
      renderUploads();
      priceRecalc();
      refreshValidation();
      renderBundleTable();
    }

    function buildSides(resetActive = false){
      const method = methodById.get(State.selectedMethodId);
      const sides = method?.sides || [];
      refs.sides.innerHTML = '';
      sideCards.clear();

      const availableIds = new Set(sides.map(s => s.id));
      Object.keys(State.uploads).forEach(key => {
        const id = Number(key);
        if (!availableIds.has(id)) {
          cleanupUpload(id);
          delete State.uploads[key];
        }
      });
      State.selectedSides = new Set(Array.from(State.selectedSides).filter(id => availableIds.has(id)));

      sides.forEach(side => {
        const card = document.createElement('div');
        card.className = 'qo-side-card';
        card.dataset.sideId = String(side.id);
        card.innerHTML = `
          <div class="qo-side-card__media"></div>
          <div class="qo-side-card__footer">
            <span class="qo-side-card__label">${side.name}</span>
          </div>
          <span class="qo-side-card__remove" data-action="remove" role="button" aria-label="Remove ${side.name}">
            <svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path>
            </svg>
          </span>
        `;
        card.addEventListener('click', event => handleSideInteraction(event, side.id));
        sideCards.set(side.id, card);
        refs.sides.appendChild(card);
      });

      if (!State.selectedSides.size && sides.length) {
        State.selectedSides.add(sides[0].id);
        State.activeSideId = sides[0].id;
      } else if (resetActive && State.selectedSides.size) {
        State.activeSideId = Array.from(State.selectedSides)[0];
      }

      updateSideCards();
    }

    function handleSideInteraction(event, sideId){
      const remove = event.target.closest('[data-action="remove"]');
      if (remove) {
        State.selectedSides.delete(sideId);
        cleanupUpload(sideId);
        delete State.uploads[sideId];
        if (!State.selectedSides.size) {
          State.activeSideId = null;
        } else if (!State.selectedSides.has(State.activeSideId)) {
          State.activeSideId = Array.from(State.selectedSides)[0];
        }
        updateSideCards();
        if (!State.selectedSides.size) {
          refreshValidation();
          priceRecalc();
          return;
        }
        renderUploads();
        refreshValidation();
        priceRecalc();
        return;
      }

      if (!State.selectedSides.has(sideId)) {
        State.selectedSides.add(sideId);
      }
      State.activeSideId = sideId;
      updateSideCards();
      if (!State.selectedSides.size) {
        refreshValidation();
        priceRecalc();
        return;
      }
      renderUploads();
      refreshValidation();
      priceRecalc();
    }

    function updateSideCards(){
      const method = methodById.get(State.selectedMethodId);
      const sides = method?.sides || [];
      const lookup = new Map(sides.map(side => [side.id, side]));

      sideCards.forEach((card, id) => {
        const side = lookup.get(id);
        const selected = State.selectedSides.has(id);
        const active = State.activeSideId === id;
        const upload = State.uploads[id];
        const hasArtwork = Boolean(upload && upload.fileName && upload.url);
        card.classList.toggle('is-selected', selected);
        card.classList.toggle('is-active', active);
        card.classList.toggle('has-artwork', hasArtwork);

        const mediaWrap = card.querySelector('.qo-side-card__media');
        if (mediaWrap) {
          mediaWrap.innerHTML = '';
          const preview = side ? (mediaFor(State.selectedColor, side.name)?.thumb || colorPreview(State.selectedColor)) : null;
          if (preview) {
            const img = document.createElement('img');
            img.src = preview;
            img.alt = side?.name || '';
            mediaWrap.appendChild(img);
          } else {
            const span = document.createElement('span');
            span.className = 'qo-side-card__placeholder';
            mediaWrap.appendChild(span);
          }
        }
      });

      const activeSide = getActiveSide();
      refs.sideLabel.textContent = activeSide?.name || '—';

      if (!State.selectedSides.size) {
        clearCurrentArtwork();
        placeholderButton.textContent = 'Select a print area';
        placeholderButton.disabled = true;
        overlay.remove();
        renderUploads();
        return;
      }

      attachOverlay();
      drawGuide();
      renderArtwork();
      syncGallery();
    }

    const FILE_ACCEPT = 'image/*,.svg,.tif,.tiff,.heic';

    function ensureUploadState(sideId){
      if (!State.uploads[sideId]) State.uploads[sideId] = { fileName: '', url: '', notes: '' };
      return State.uploads[sideId];
    }

    function cleanupUpload(sideId){
      const upload = State.uploads[sideId];
      if (upload?.url && upload.url.startsWith('blob:')) {
        URL.revokeObjectURL(upload.url);
      }
      if (upload?.konva) delete upload.konva;
      if (upload?.__image) delete upload.__image;
    }

    function removeArtwork(sideId){
      if (sideId == null) return;
      const existing = State.uploads[sideId];
      const notes = existing?.notes || '';
      cleanupUpload(sideId);
      State.uploads[sideId] = { notes };
      if (State.activeSideId === sideId) {
        clearCurrentArtwork();
      }
      renderUploads();
      updateSideCards();
      renderArtwork();
      refreshValidation();
    }

    function assignUpload(sideId, payload = {}, options = {}){
      if (sideId == null || !payload || !payload.url) return;
      const closeLibrary = options.closeLibrary !== false;
      const existing = ensureUploadState(sideId);
      const notes = existing?.notes || '';
      cleanupUpload(sideId);
      if (payload.remote) {
        recordRecentUpload(payload.remote);
      }
      State.uploads[sideId] = {
        fileName: payload.fileName || existing.fileName || '',
        url: payload.url,
        size: payload.size ?? existing.size ?? null,
        mime: payload.mime ?? existing.mime ?? null,
        remote: payload.remote || null,
        source: payload.source || 'local',
        notes
      };
      setActiveSide(sideId);
      updateSideCards();
      renderUploads();
      drawGuide();
      renderArtwork();
      refreshValidation();
      if (closeLibrary && artworkLibraryModal && artworkLibrarySideId === sideId) {
        artworkLibraryModal.close();
      } else {
        refreshArtworkLibraryModal();
      }
    }

    function handleFileSelection(sideId, file){
      if (!file) return;
      const url = URL.createObjectURL(file);
      assignUpload(sideId, {
        fileName: file.name,
        url,
        size: file.size,
        mime: file.type,
        source: 'local'
      });
    }

    function loadStylesheetOnce(href, id){
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve();
          return;
        }
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.id = id;
        link.onload = () => resolve();
        link.onerror = () => reject(new Error(`Failed to load stylesheet ${href}`));
        document.head.appendChild(link);
      });
    }

    function loadScriptOnce(src, id){
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script ${src}`));
        document.head.appendChild(script);
      });
    }

    async function ensureUppy(){
      if (uploader.instance) return uploader.instance;
      try {
        await Promise.all([
          loadStylesheetOnce('https://releases.transloadit.com/uppy/v3.13.1/uppy.min.css', 'uppy-global-style'),
          loadScriptOnce('https://releases.transloadit.com/uppy/v3.13.1/uppy.min.js', 'uppy-global-script')
        ]);
      } catch (err) {
        console.warn('[quickOrder] failed to load Uppy assets', err);
        throw err;
      }
      const UppyNS = window.Uppy;
      const CoreCtor = (typeof UppyNS === 'function') ? UppyNS
        : (typeof UppyNS?.Uppy === 'function') ? UppyNS.Uppy
        : (typeof UppyNS?.Core === 'function') ? UppyNS.Core
        : null;
      if (!CoreCtor) throw new Error('Uppy not available');
      const uppy = new CoreCtor({
        autoProceed: true,
        restrictions: {
          maxNumberOfFiles: 1,
          maxFileSize: 50 * 1024 * 1024,
          allowedFileTypes: ['image/*', '.svg', '.tif', '.tiff', '.heic']
        }
      });
      const DashboardPlugin = UppyNS?.Dashboard || UppyNS?.plugins?.Dashboard;
      if (DashboardPlugin) uppy.use(DashboardPlugin, {
        inline: false,
        trigger: null,
        target: 'body',
        closeAfterFinish: true,
        showProgressDetails: true,
        proudlyDisplayPoweredByUppy: false,
        disabledInformer: false,
        hideUploadButton: true,
        showLinkToFileUploadResult: false,
        note: 'By uploading your artwork, you confirm that you have the rights to use it and comply with our terms of service.',
        locale: {
          strings: {
            dropPaste: 'DROP FILES HERE'
          }
        }
      });
      const googleDrivePlugin = UppyNS?.GoogleDrive;
      const dropboxPlugin = UppyNS?.Dropbox;
      const urlPlugin = UppyNS?.Url;
      const webcamPlugin = UppyNS?.Webcam;
      const xhrPlugin = UppyNS?.XHRUpload;
      if (googleDrivePlugin) uppy.use(googleDrivePlugin, { companionUrl: uploader.companionUrl });
      if (dropboxPlugin) uppy.use(dropboxPlugin, { companionUrl: uploader.companionUrl });
      if (urlPlugin) uppy.use(urlPlugin, { companionUrl: uploader.companionUrl });
      if (webcamPlugin) uppy.use(webcamPlugin, { modes: ['picture'] });
      if (xhrPlugin && uploader.endpoints.upload) {
        const headers = {};
        const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrf) headers['X-CSRF-TOKEN'] = csrf;
        uppy.use(xhrPlugin, {
          endpoint: uploader.endpoints.upload,
          fieldName: 'file',
          formData: true,
          limit: 1,
          withCredentials: true,
          headers
        });
      }
      uppy.on('dashboard:modal-open', () => document.body.classList.add('qo-uppy-active'));
      uppy.on('dashboard:modal-closed', () => document.body.classList.remove('qo-uppy-active'));
      uppy.on('file-added', file => {
        if (uploader.sideId) {
          uppy.setFileMeta(file.id, {
            side_id: uploader.sideId,
            customer_id: meta.customer_id || ''
          });
        }
      });
      uppy.on('complete', handleUppyComplete);
      uploader.instance = uppy;
      return uppy;
    }

    async function launchUploadFlow(sideId, fallbackInput){
      if (sideId == null) {
        showToast('Select a print area before uploading artwork');
        return;
      }
      try {
        const uppy = await ensureUppy();
        const dashboard = uppy.getPlugin ? uppy.getPlugin('Dashboard') : null;
        uploader.sideId = sideId;
        if (typeof uppy.cancelAll === 'function') uppy.cancelAll();
        if (typeof uppy.reset === 'function') {
          uppy.reset();
        } else if (typeof uppy.getFiles === 'function' && typeof uppy.removeFile === 'function') {
          uppy.getFiles().forEach(file => uppy.removeFile(file.id));
        }
        if (typeof uppy.setMeta === 'function') uppy.setMeta({
          side_id: sideId,
          customer_id: meta.customer_id || ''
        });
        if (dashboard && typeof dashboard.openModal === 'function') {
          dashboard.openModal();
        } else if (fallbackInput) {
          fallbackInput.click();
        }
      } catch (err) {
        console.warn('[quickOrder] using fallback uploader', err);
        document.body.classList.remove('qo-uppy-active');
        if (fallbackInput) {
          fallbackInput.click();
        } else {
          showToast('Upload failed to initialize');
        }
      }
    }

    function recordRecentUpload(entry){
      if (!entry || !entry.url) return;
      removeEntryFromLibrary(entry);
      const match = (item) => {
        if (!item) return false;
        if (entry.id && item.id) return item.id === entry.id;
        return item.url === entry.url;
      };
      const list = uploadLibrary.recent.filter(item => !match(item));
      uploadLibrary.recent = [entry, ...list].slice(0, 12);
      refreshArtworkLibraryModal();
    }

    function handleUppyComplete(result){
      const sideId = uploader.sideId;
      uploader.sideId = null;
      if (!result || !Array.isArray(result.successful) || !result.successful.length) {
        if (result?.failed?.length) {
          result.failed.forEach(item => {
            const message = item?.error?.message || 'Upload failed';
            showToast(message, 'danger');
          });
        }
        return;
      }
      const file = result.successful[0];
      const responseUpload = file?.response?.body?.upload;
      if (sideId != null) {
        if (responseUpload?.url) {
          recordRecentUpload(responseUpload);
          assignUpload(sideId, {
            fileName: responseUpload.name,
            url: responseUpload.url,
            size: responseUpload.size,
            mime: responseUpload.mime,
            source: responseUpload.source || 'remote',
            remote: responseUpload
          });
        } else if (file?.data) {
          const blobUrl = URL.createObjectURL(file.data);
          recordRecentUpload({
            id: file.id,
            name: file.name,
            url: blobUrl,
            size: file.size,
            mime: file.type,
            uploaded_at: new Date().toISOString(),
            source: 'local'
          });
          assignUpload(sideId, {
            fileName: file.name,
            url: blobUrl,
            size: file.size,
            mime: file.type,
            source: 'local'
          });
        }
      }
      if (Array.isArray(result.failed) && result.failed.length) {
        result.failed.forEach(item => {
          const message = item?.error?.message || 'Upload failed';
          showToast(message, 'danger');
        });
      }
      const dashboard = uploader.instance?.getPlugin('Dashboard');
      dashboard?.closeModal?.();
      uploader.instance?.reset?.();
      fetchRecentUploads();
      if (meta.customer_id) {
        fetchCustomerArtworks(meta.customer_id, { silent: true });
      }
    }

    async function fetchRecentUploads(){
      if (!uploader.endpoints.recent) return;
      if (uploadLibrary.recentLoading) return;
      uploadLibrary.recentLoading = true;
      refreshArtworkLibraryModal();
      try {
        const res = await fetch(uploader.endpoints.recent, { credentials: 'include' });
        if (!res.ok) throw new Error('Recent uploads request failed');
        const data = await res.json();
        uploadLibrary.recent = (Array.isArray(data?.uploads) ? data.uploads : []).slice(0, 12);
      } catch (err) {
        console.warn('[quickOrder] recent uploads unavailable', err);
      } finally {
        uploadLibrary.recentLoading = false;
        refreshArtworkLibraryModal();
      }
    }

    async function fetchCustomerArtworks(customerId, { force = false, silent = false } = {}){
      if (!customerId) return;
      if (uploadLibrary.customerLoading) return;
      if (uploadLibrary.customerChecked && !force) return;
      const endpoint = uploader.endpoints.customer;
      if (!endpoint) return;
      uploadLibrary.customerLoading = true;
      refreshArtworkLibraryModal();
      try {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('customer_id', customerId);
        const res = await fetch(url.toString(), { credentials: 'include' });
        if (!res.ok) throw new Error('Customer artwork request failed');
        const data = await res.json();
        uploadLibrary.customerChecked = true;
        uploadLibrary.requiresAuth = Boolean(data?.requires_auth);
        uploadLibrary.past = (Array.isArray(data?.artworks) ? data.artworks : []).slice(0, 24);
      } catch (err) {
        uploadLibrary.customerChecked = true;
        uploadLibrary.requiresAuth = true;
        uploadLibrary.past = [];
        if (!silent) console.warn('[quickOrder] customer artwork unavailable', err);
      } finally {
        uploadLibrary.customerLoading = false;
        refreshArtworkLibraryModal();
      }
    }

    function refreshArtworkLibraryModal(){
      if (!artworkLibraryModal || !artworkLibraryBody || artworkLibrarySideId == null) return;
      renderArtworkLibraryContent(artworkLibraryBody, artworkLibrarySideId);
    }

    function openArtworkLibrary(sideId, { fallbackInput } = {}){
      if (!sideId) {
        showToast('Select a print area before uploading artwork');
        return;
      }
      artworkLibrarySideId = sideId;
      artworkLibraryFallbackInput = fallbackInput || null;

      if (!uploadLibrary.recent.length && !uploadLibrary.recentLoading) {
        fetchRecentUploads();
      }
      if (meta.customer_id && (!uploadLibrary.customerChecked || uploadLibrary.requiresAuth) && !uploadLibrary.customerLoading) {
        fetchCustomerArtworks(meta.customer_id, { silent: true });
      }

      const body = document.createElement('div');
      body.className = 'qo-artwork-library';
      renderArtworkLibraryContent(body, sideId);
      artworkLibraryModal = openModal({
        title: 'Artwork Library',
        body,
        modalClass: 'qo-modal--artwork',
        onClose: () => {
          artworkLibraryModal = null;
          artworkLibraryBody = null;
          artworkLibrarySideId = null;
          artworkLibraryFallbackInput = null;
        }
      });
      artworkLibraryBody = artworkLibraryModal.body || body;
    }

    function renderArtworkLibraryContent(container, sideId){
      container.innerHTML = '';

      const banner = document.createElement('div');
      banner.className = 'qo-artwork-library__banner';
      banner.innerHTML = '<p>Your order will be triple-checked for quality, and we guarantee it will print perfectly—even if the online preview doesn’t look perfect. If you have any concerns, don’t hesitate to contact us at 1-855-530-0032.</p>';
      container.appendChild(banner);

      const sections = [];
      if (uploadLibrary.recent.length) {
        sections.push({ title: uploadLibrary.past.length ? 'Recent uploads' : '', items: uploadLibrary.recent });
      }
      if (uploadLibrary.past.length) {
        sections.push({ title: 'From past orders', items: uploadLibrary.past });
      }

      const isLoading = uploadLibrary.recentLoading || uploadLibrary.customerLoading;

      if (isLoading) {
        const loading = document.createElement('div');
        loading.className = 'qo-artwork-library__message';
        loading.textContent = 'Loading your artwork library…';
        container.appendChild(loading);
      }

      if (!sections.length && !isLoading) {
        const empty = document.createElement('div');
        empty.className = 'qo-artwork-library__empty';
        empty.textContent = 'No artwork uploaded yet.';
        container.appendChild(empty);
      }

      if (sections.length) {
        const sectionWrap = document.createElement('div');
        sectionWrap.className = 'qo-artwork-library__sections';
        sections.forEach(section => sectionWrap.appendChild(buildArtworkSection(section.title, section.items, sideId)));
        container.appendChild(sectionWrap);
      }

      const uploadBox = document.createElement('button');
      uploadBox.type = 'button';
      uploadBox.className = 'qo-artwork-library__upload';
      uploadBox.innerHTML = '<span class="qo-artwork-library__upload-icon">+</span><span>Upload Additional Artwork</span>';
      uploadBox.addEventListener('click', () => {
        launchUploadFlow(sideId, artworkLibraryFallbackInput);
      });
      container.appendChild(uploadBox);

      if (!meta.customer_id || uploadLibrary.requiresAuth) {
        const loginWrap = document.createElement('div');
        loginWrap.className = 'qo-artwork-library__login';
        const loginBtn = document.createElement('button');
        loginBtn.type = 'button';
        loginBtn.className = 'qo-artwork-library__login-link';
        loginBtn.innerHTML = '<span class="qo-artwork-library__login-icon" aria-hidden="true"></span> Log in to sync artworks from your past orders';
        loginBtn.addEventListener('click', () => {
          window.location.href = meta.login_url || '/account/login';
        });
        loginWrap.appendChild(loginBtn);
        container.appendChild(loginWrap);
      } else {
        const syncWrap = document.createElement('div');
        syncWrap.className = 'qo-artwork-library__login';
        const syncBtn = document.createElement('button');
        syncBtn.type = 'button';
        syncBtn.className = 'qo-artwork-library__login-link';
        syncBtn.innerHTML = '<span class="qo-artwork-library__login-icon" aria-hidden="true"></span> Sync artworks from your past orders';
        syncBtn.addEventListener('click', () => fetchCustomerArtworks(meta.customer_id, { force: true }));
        syncWrap.appendChild(syncBtn);
        container.appendChild(syncWrap);
      }
    }

    function buildArtworkSection(title, items, sideId){
      const section = document.createElement('div');
      section.className = 'qo-artwork-section';
      if (title) {
        const heading = document.createElement('div');
        heading.className = 'qo-artwork-section__heading';
        heading.textContent = title;
        section.appendChild(heading);
      }
      const grid = document.createElement('div');
      grid.className = 'qo-artwork-grid';
      items.forEach(entry => grid.appendChild(buildArtworkCard(entry, sideId)));
      section.appendChild(grid);
      return section;
    }

    function buildArtworkCard(entry, sideId){
      const card = document.createElement('div');
      card.className = 'qo-artwork-card';
      card.tabIndex = 0;

      const select = () => {
        assignUpload(sideId, {
          fileName: entry.name,
          url: entry.url,
          size: entry.size,
          mime: entry.mime,
          source: entry.source || 'recent',
          remote: entry
        });
      };

      const thumb = document.createElement('div');
      thumb.className = 'qo-artwork-card__thumb';
      const previewUrl = entry.preview_url || entry.url;
      if (previewUrl) {
        const img = document.createElement('img');
        img.src = previewUrl;
        img.alt = entry.name || 'Artwork preview';
        thumb.appendChild(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'qo-artwork-card__thumb-placeholder';
        placeholder.textContent = 'No preview';
        thumb.appendChild(placeholder);
      }
      card.appendChild(thumb);

      const name = document.createElement('div');
      name.className = 'qo-artwork-card__name';
      name.textContent = entry.name || 'Artwork';
      card.appendChild(name);

      const actions = document.createElement('div');
      actions.className = 'qo-artwork-card__actions';


      if (entry.id) {
        const deleteBtn = document.createElement('button');
        deleteBtn.type = 'button';
        deleteBtn.className = 'qo-artwork-card__delete';
        deleteBtn.textContent = 'Delete';
        deleteBtn.addEventListener('click', event => {
          event.stopPropagation();
          deleteLibraryEntry(entry);
        });
        actions.appendChild(deleteBtn);
      }
      card.appendChild(actions);

      card.addEventListener('click', select);
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select();
        }
      });

      return card;
    }

    function removeEntryFromLibrary(entry){
      const match = (item) => {
        if (!item) return false;
        if (entry?.id && item.id) return item.id === entry.id;
        return entry?.url && item.url === entry.url;
      };
      uploadLibrary.recent = uploadLibrary.recent.filter(item => !match(item));
      uploadLibrary.past = uploadLibrary.past.filter(item => !match(item));
    }

    async function deleteLibraryEntry(entry){
      removeEntryFromLibrary(entry);
      refreshArtworkLibraryModal();
      if (!entry?.id || !uploader.endpoints.upload) return;
      try {
        const url = `${uploader.endpoints.upload}/${encodeURIComponent(entry.id)}`;
        const res = await fetch(url, { method: 'DELETE', credentials: 'include' });
        if (!res.ok) throw new Error('Delete failed');
        const data = await res.json().catch(() => null);
        if (Array.isArray(data?.uploads)) {
          uploadLibrary.recent = data.uploads.slice(0, 12);
        }
      } catch (err) {
        console.warn('[quickOrder] Failed to delete artwork', err);
        showToast('Unable to delete artwork', 'danger');
        fetchRecentUploads();
        if (meta.customer_id) {
          fetchCustomerArtworks(meta.customer_id, { force: true, silent: true });
        }
      } finally {
        refreshArtworkLibraryModal();
      }
    }

    function renderUploads(){
      if (!refs.uploadList) return;
      const sides = getSelectedSides();
      refs.uploadList.innerHTML = '';
      removeArtworkButton.classList.remove('is-visible');
      removeArtworkButton.disabled = true;
      if (!sides.length) {
        refs.uploadList.innerHTML = '<div class="qo-upload-empty">Select a print area to upload artwork.</div>';
        clearCurrentArtwork();
        placeholderButton.textContent = 'Select a print area';
        placeholderButton.classList.add('is-visible');
        placeholderButton.disabled = true;
        latestFallbackInput = null;
        return;
      }
      let activeSide = getActiveSide();
      if (!activeSide) {
        State.activeSideId = sides[0].id;
        activeSide = sides[0];
        updateSideCards();
      }
      if (!activeSide) {
        placeholderButton.classList.add('is-visible');
        placeholderButton.disabled = true;
        latestFallbackInput = null;
        return;
      }

      const upload = ensureUploadState(activeSide.id);
      const hasFile = Boolean(upload.fileName && upload.url);
      if (!hasFile) {
        currentArtworkNode = null;
        persistCurrentArtwork = null;
      }
      placeholderButton.textContent = `Upload ${activeSide.name} Artwork`;
      placeholderButton.classList.toggle('is-visible', !hasFile);
      placeholderButton.disabled = hasFile;
      removeArtworkButton.classList.toggle('is-visible', hasFile);
      removeArtworkButton.disabled = !hasFile;
      const card = document.createElement('div');
      card.className = 'qo-upload-card' + (hasFile ? ' has-file' : '');
      card.dataset.side = activeSide.id;
      card.innerHTML = `
        <div class="qo-upload-card__header">
          
          <button type="button" class="qo-upload-card__trigger" data-action="${hasFile ? 'replace' : 'upload'}">
            ${hasFile ? 'Replace artwork' : 'Upload artwork'}
            <strong>${activeSide.name}</strong>
          </button>
        </div>
        <div class="qo-upload-card__file ${hasFile ? '' : 'qo-upload-card__file--empty'}">
          ${hasFile ? `<span class=\"qo-upload-card__file-name\">${upload.fileName}</span>
          <div class=\"qo-upload-card__file-actions\">
            <button type=\"button\" class=\"qo-upload-card__link\" data-action=\"replace\">Replace</button>
            <button type=\"button\" class=\"qo-upload-card__link\" data-action=\"delete\">Delete</button>
          </div>` : '<span>No artwork uploaded.</span>'}
        </div>
        <label class="qo-upload-card__notes-label" for="qo-note-${activeSide.id}">
          Add notes for our designers
          <span>(Optional)</span>
        </label>
        <textarea id="qo-note-${activeSide.id}" class="qo-upload-card__notes" data-side="${activeSide.id}" placeholder="Ex: Remove background and change the black text to white">${upload.notes || ''}</textarea>
      `;
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = FILE_ACCEPT;
      fileInput.hidden = true;
      card.appendChild(fileInput);
      const trigger = card.querySelector('[data-action="upload"],[data-action="replace"]');
      trigger?.addEventListener('click', () => {
        fileInput.value = '';
        openArtworkLibrary(activeSide.id, { fallbackInput: fileInput });
      });
      fileInput.addEventListener('change', event => {
        const selectedFile = event.target.files?.[0];
        handleFileSelection(activeSide.id, selectedFile);
      });
      latestFallbackInput = fileInput;
      const deleteBtn = card.querySelector('[data-action="delete"]');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', () => {
          removeArtwork(activeSide.id);
        });
      }
      const notesField = card.querySelector('.qo-upload-card__notes');
      notesField.addEventListener('input', e => {
        ensureUploadState(activeSide.id).notes = e.target.value;
      });
      if (hasFile) {
        const toolbar = document.createElement('div');
        toolbar.className = 'qo-upload-card__toolbar';
        toolbar.innerHTML = `
          <button type="button" data-tool="rotate-left" aria-label="Rotate left">⟲ 15°</button>
          <button type="button" data-tool="rotate-right" aria-label="Rotate right">⟳ 15°</button>
          <button type="button" data-tool="flip-horizontal" aria-label="Flip horizontally">Flip H</button>
          <button type="button" data-tool="flip-vertical" aria-label="Flip vertically">Flip V</button>
          <button type="button" data-tool="center-horizontal" aria-label="Center horizontally">Center H</button>
          <button type="button" data-tool="center-vertical" aria-label="Center vertically">Center V</button>
          <button type="button" data-tool="reset" aria-label="Reset artwork">Reset</button>
        `;
        toolbar.addEventListener('click', event => {
          const btn = event.target.closest('button[data-tool]');
          if (!btn) return;
          applyArtworkTool(btn.dataset.tool);
        });
        card.appendChild(toolbar);
      }
      refs.uploadList.appendChild(card);
      placeholderButton.disabled = hasFile;
    }


    function clearCurrentArtwork(){
      if (currentArtworkNode) {
        try { currentArtworkNode.destroy(); } catch(e) {}
        currentArtworkNode = null;
      }
      persistCurrentArtwork = null;
      guidesVisible = true;
      if (transformer) transformer.nodes([]);
      if (artworkLayer) {
        artworkLayer.draw();
      }
      if (stage) stage.batchDraw();
      refreshGuideVisibility();
      removeArtworkButton.classList.remove('is-visible');
      removeArtworkButton.disabled = true;
    }

    function applyArtworkTool(action){
      const node = currentArtworkNode;
      if (!node){
        showToast('Upload artwork before adjusting it');
        return;
      }
      const rotationStep = 15;
      switch(action){
        case 'rotate-left':
          node.rotate(-rotationStep);
          break;
        case 'rotate-right':
          node.rotate(rotationStep);
          break;
        case 'flip-horizontal':
          node.scaleX(node.scaleX() * -1 || -1);
          break;
        case 'flip-vertical':
          node.scaleY(node.scaleY() * -1 || -1);
          break;
        case 'center-horizontal':
          if (currentGuidePx && currentGuidePx.px) {
            const px = currentGuidePx.px;
            node.x(px.x + px.width / 2);
          }
          break;
        case 'center-vertical':
          if (currentGuidePx && currentGuidePx.px) {
            const px = currentGuidePx.px;
            node.y(px.y + px.height / 2);
          }
          break;
        case 'reset':
          if (currentGuidePx && currentGuidePx.px) {
            const px = currentGuidePx.px;
            const baseWidth = node.getAttr('_baseWidth') || node.width();
            const baseHeight = node.getAttr('_baseHeight') || node.height();
            const defaultScale = node.getAttr('_defaultScale') || Math.min(px.width / baseWidth, px.height / baseHeight);
            const targetScale = ALLOW_ARTWORK_OVERFLOW ? defaultScale * INITIAL_ARTWORK_SCALE : defaultScale;
            node.scaleX(targetScale);
            node.scaleY(targetScale);
            node.rotation(0);
            node.position({ x: px.x + px.width / 2, y: px.y + px.height / 2 });
          }
          break;
        default:
          return;
      }
      if (!ALLOW_ARTWORK_OVERFLOW) {
        ensureNodeWithinArea(node);
      }
      if (persistCurrentArtwork) persistCurrentArtwork();
      if (artworkLayer) artworkLayer.batchDraw();
      if (stage) stage.batchDraw();
    }

    function renderBundleTable(){
      const rows = getActiveCriteria()?.volume_discounts || [];
      if (!rows.length) {
        refs.bundleTbl.innerHTML = '';
        return;
      }
      const table = document.createElement('table');
      table.className = 'qo-bundle-table';
      table.innerHTML = `<thead><tr><th>Bundle quantity</th><th>Discount</th></tr></thead><tbody></tbody>`;
      const tbody = table.querySelector('tbody');
      rows.forEach(row => {
        const tr = document.createElement('tr');
        tr.innerHTML = `<td>${row.qty}</td><td>${row.type === 'percentage' ? `${row.value}%` : formatMoney((row.value || 0) * 100)}</td>`;
        tbody.appendChild(tr);
      });
      refs.bundleTbl.innerHTML = '';
      refs.bundleTbl.appendChild(table);
    }

    function updateRestrictionsNotice(){
      if (!refs.restrictions) return;
      const messages = [];
      const method = methodById.get(State.selectedMethodId);
      const criteria = getActiveCriteria();
      const totalQty = getTotalQty();
      if (method?.min_order_qty) {
        messages.push(`${method.name} requires a minimum of ${method.min_order_qty} pieces.`);
      }
      if (criteria?.min_order_qty) {
        messages.push(`${criteria.title} minimum order is ${criteria.min_order_qty} pieces.`);
      }
      if (criteria?.qty_increment) {
        messages.push(`Quantities must be in multiples of ${criteria.qty_increment}.`);
      }
      if (messages.length) {
        refs.restrictions.innerHTML = messages.map(m => `<div>${m}</div>`).join('');
        refs.restrictions.classList.remove('is-hidden');
      } else {
        refs.restrictions.innerHTML = '';
        refs.restrictions.classList.add('is-hidden');
      }
    }

    function renderRows(){
      refs.rowsWrap.innerHTML = '';
      State.rows.forEach((row, idx) => {
        const def = COLORS[row.color];
        if (!def) return;
        const card = document.createElement('div');
        card.className = 'qo-row';
        const preview = colorPreview(row.color);
        card.innerHTML = `
          <div class="qo-row__head">
            <div class="qo-row__info">
              <span class="qo-row__thumb">${preview ? `<img src="${preview}" alt="${row.color}">` : ''}</span>
              <div>
                <div class="qo-row__color">${row.color}</div>
                <button type="button" class="qo-row__toggle">Close sizes</button>
              </div>
            </div>
            <button type="button" class="qo-row__remove" title="Remove ${row.color}">🗑</button>
          </div>
          <div class="qo-row__sizes"></div>
        `;
        const sizesWrap = card.querySelector('.qo-row__sizes');
        const sizesByName = Object.fromEntries(def.sizes.map(s => [s.size, s]));
        sizeOrder.forEach(sz => {
          const s = sizesByName[sz];
          if (!s) return;
          const qty = row.qtyBySize[sz] || 0;
          const price = priceForVariant(s.variantId);
          const baseCents = s.price;
          const discounted = price.each;
          const compareDisplay = discounted < baseCents ? formatMoney(baseCents) : '';
          const box = document.createElement('div');
          box.className = 'qo-size';
          box.dataset.variantId = s.variantId;
          box.dataset.basePrice = baseCents;
          box.innerHTML = `
            <input type="number" min="0" step="1" value="${qty}" class="qo-size__input" aria-label="${row.color} ${sz} quantity">
            <div class="qo-size__label">${sz}</div>
            <div>
            <div class="qo-size__price">${formatMoney(discounted)}</div>
            <div class="qo-size__compare">${compareDisplay}</div>
            </div>
          `;
          const input = box.querySelector('input');
          input.addEventListener('input', e => {
            const value = clamp(parseInt(e.target.value, 10) || 0, 0, 9999);
            row.qtyBySize[sz] = value;
            input.value = value;
            priceRecalc();
          });
          sizesWrap.appendChild(box);
        });
        card.querySelector('.qo-row__remove').addEventListener('click', () => {
          if (State.rows.length === 1) {
            showToast('You must select at least one color for this product');
            return;
          }
          State.rows.splice(idx, 1);
          renderRows();
          priceRecalc();
        });
        card.querySelector('.qo-row__toggle').addEventListener('click', (event) => {
          event.preventDefault();
          card.classList.toggle('is-collapsed');
        });
        refs.rowsWrap.appendChild(card);
      });
    }

    function currentDiscountPercent(){
      const totalQty = getTotalQty();
      const discounts = (getActiveCriteria()?.volume_discounts || []).slice().sort((a, b) => b.qty - a.qty);
      for (const tier of discounts) {
        if (totalQty >= tier.qty) return tier.type === 'percentage' ? tier.value : 0;
      }
      return 0;
    }

    function priceForVariant(variantId){
      const variant = variants.find(v => v.id === variantId);
      if (!variant) return { each: 0, compare: 0 };
      const base = variant.price;
      const compare = variant.compare_at_price || variant.price;
      const method = methodById.get(State.selectedMethodId);
      let addon = 0;
      if (method) {
        (method.sides || []).forEach(side => {
          if (!State.selectedSides.has(side.id)) return;
          const pricing = side.pricing || {};
          if (pricing.type === 'fixed') addon += (pricing.value || 0) * 100;
          else if (pricing.type === 'percentage') addon += base * (pricing.value || 0);
        });
      }
      const discount = currentDiscountPercent();
      const each = Math.max(0, (base + addon) * (1 - discount / 100));
      return { each: Math.round(each), compare };
    }

    function priceRecalc(){
      const lines = [];
      State.rows.forEach(row => {
        const def = COLORS[row.color];
        if (!def) return;
        def.sizes.forEach(s => {
          const qty = parseInt(row.qtyBySize[s.size] || 0, 10) || 0;
          if (qty) {
            const price = priceForVariant(s.variantId);
            lines.push({ qty, price });
          }
        });
      });
      const totalQty = lines.reduce((sum, item) => sum + item.qty, 0);
      const total = lines.reduce((sum, item) => sum + item.qty * item.price.each, 0);
      const compare = lines.reduce((sum, item) => sum + item.qty * item.price.compare, 0);
      if (refs.totalsWrap) {
        refs.totalsWrap.classList.toggle('is-hidden', total <= 0);
      }
      if (refs.total) {
        if (total > 0) {
          refs.total.textContent = formatMoney(total);
          refs.total.classList.remove('qo-total--hidden');
        } else {
          refs.total.textContent = '';
          refs.total.classList.add('qo-total--hidden');
        }
      }
      refs.compare.textContent = compare > total ? formatMoney(compare) : '';
      refs.each.textContent = totalQty ? `${formatMoney(Math.round(total / totalQty))} / item` : '';
      refs.items.textContent = totalQty ? `Total items: ${totalQty}` : '';

      refs.rowsWrap.querySelectorAll('.qo-size').forEach(box => {
        const variantId = Number(box.dataset.variantId);
        const basePrice = Number(box.dataset.basePrice || 0);
        const price = priceForVariant(variantId);
        const priceEl = box.querySelector('.qo-size__price');
        const compareEl = box.querySelector('.qo-size__compare');
        const discounted = price.each < basePrice;
        
        if (priceEl) {
          priceEl.textContent = formatMoney(price.each);
          priceEl.classList.toggle('is-sale', discounted);
        }
        if (compareEl) {
          compareEl.textContent = discounted ? formatMoney(basePrice) : '';
        }
      });

      updateMethodCards();
      refreshValidation();
      updateRestrictionsNotice();
      renderBundleTable();
    }

    function getArtworkArea(side){
      const area = side?.artwork_area;
      if (area && typeof area === 'object') {
        return {
          x: clamp01(area.x),
          y: clamp01(area.y),
          width: clamp01(area.width),
          height: clamp01(area.height)
        };
      }
      return { x: 0.18, y: 0.16, width: 0.62, height: 0.64 };
    }

    function refreshGuideVisibility(){
      const hasArtwork = Boolean(currentArtworkNode);
      const shouldShow = (!hasArtwork) || guidesVisible;
      if (guideRect) guideRect.visible(Boolean(currentGuidePx) && shouldShow);
      if (gridGroup) gridGroup.visible(Boolean(currentGuidePx) && shouldShow);
      if (dimensionText) {
        const hasText = Boolean(dimensionText.text());
        dimensionText.visible(Boolean(currentGuidePx) && shouldShow && hasText);
      }
      if (guideLayer) guideLayer.batchDraw();
    }

    function drawGuide(){
      if (!konvaReady || !stage || !guideRect) return;
      const active = getActiveSide();
      if (!active) {
        currentGuidePx = null;
        refreshGuideVisibility();
        return;
      }
      const area = getArtworkArea(active);
      const { width, height } = stage.size();
      const px = {
        x: area.x * width,
        y: area.y * height,
        width: Math.max(20, area.width * width),
        height: Math.max(20, area.height * height)
      };
      currentGuidePx = { area, px };
      guideRect.setAttrs(px);
      if (gridGroup && gridHorizontal && gridVertical) {
        gridGroup.position({ x: px.x, y: px.y });
        gridHorizontal.points([0, px.height / 2, px.width, px.height / 2]);
        gridVertical.points([px.width / 2, 0, px.width / 2, px.height]);
      }
      const dims = getActiveSide()?.dimensions_cm;
      if (dimensionText) {
        if (dims && (dims.width || dims.height)) {
          const w = dims.width || dims.width_cm || dims.w;
          const h = dims.height || dims.height_cm || dims.h;
          dimensionText.text(`${w || '?'}cm × ${h || '?'}cm`);
          dimensionText.position({ x: px.x + 8, y: px.y + 8 });
        } else {
          dimensionText.text('');
        }
      }
      refreshGuideVisibility();
    }

    function loadImage(url){
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.src = url;
      });
    }

    async function renderArtwork(){
      renderToken += 1;
      const token = renderToken;
      const upload = State.activeSideId != null ? State.uploads[State.activeSideId] : null;
      if (!konvaReady || !stage || !artworkLayer || !upload || !upload.url || !currentGuidePx) {
        removeArtworkButton.classList.remove('is-visible');
        removeArtworkButton.disabled = true;
        clearCurrentArtwork();
        return;
      }
      clearCurrentArtwork();
      removeArtworkButton.classList.add('is-visible');
      removeArtworkButton.disabled = false;
      placeholderButton.classList.remove('is-visible');
      placeholderButton.disabled = true;
      try {
        let img = upload.__image;
        if (!(img instanceof Image) || img.src !== upload.url) {
          img = await loadImage(upload.url);
          upload.__image = img;
        }
        if (token !== renderToken) return;
        const areaPx = currentGuidePx.px;
        const baseWidth = img.width;
        const baseHeight = img.height;
        const defaultScale = baseScaleFor(areaPx, baseWidth, baseHeight) || 1;
        const hydrated = hydrateArtworkState(upload.konva, areaPx, defaultScale);
        const scaleMultiplierX = hydrated.multiplierX ?? INITIAL_ARTWORK_SCALE;
        const scaleMultiplierY = hydrated.multiplierY ?? INITIAL_ARTWORK_SCALE;
        const node = new Konva.Image({
          image: img,
          width: baseWidth,
          height: baseHeight,
          draggable: true
        });
        node.offsetX(baseWidth / 2);
        node.offsetY(baseHeight / 2);
        node.position({
          x: areaPx.x + hydrated.centerX * areaPx.width,
          y: areaPx.y + hydrated.centerY * areaPx.height
        });
        node.scaleX(defaultScale * scaleMultiplierX);
        node.scaleY(defaultScale * scaleMultiplierY);
        node.rotation(hydrated.rotation);
        node.setAttrs({ _baseWidth: baseWidth, _baseHeight: baseHeight, _defaultScale: defaultScale });
        if (!ALLOW_ARTWORK_OVERFLOW) {
          ensureNodeWithinArea(node);
          node.dragBoundFunc(pos => clampPointWithinArea(pos, node));
        }

        const persistState = () => {
          const latestPx = currentGuidePx?.px;
          if (!latestPx) return;
          if (!ALLOW_ARTWORK_OVERFLOW) ensureNodeWithinArea(node);
          persistArtworkState(upload, node, latestPx, defaultScale);
          if (transformer) {
            transformer.nodes([node]);
            transformer.moveToTop();
          }
          if (artworkLayer) artworkLayer.batchDraw();
          if (stage) stage.batchDraw();
        };

        node.on('mouseenter', () => {
          guidesVisible = true;
          refreshGuideVisibility();
        });
        node.on('mouseleave', () => {
          if (!node.isDragging()) {
            guidesVisible = false;
            refreshGuideVisibility();
          }
        });
        node.on('dragstart', () => {
          guidesVisible = true;
          refreshGuideVisibility();
        });
        node.on('dragend', () => {
          persistState();
          guidesVisible = false;
          refreshGuideVisibility();
        });
        node.on('transformstart', () => {
          guidesVisible = true;
          refreshGuideVisibility();
        });
        node.on('transformend', () => {
          persistState();
          guidesVisible = false;
          refreshGuideVisibility();
        });
        artworkLayer.add(node);
        persistState();
        currentArtworkNode = node;
        persistCurrentArtwork = persistState;
        guidesVisible = false;
        refreshGuideVisibility();
        if (transformer) {
          transformer.nodes([node]);
          transformer.moveToTop();
        }
        artworkLayer.draw();
        if (stage) stage.batchDraw();
      } catch (err) {
        currentArtworkNode = null;
        persistCurrentArtwork = null;
        if (upload && upload.__image) delete upload.__image;
        console.error('[quickOrder] Failed to render artwork', err);
        removeArtworkButton.classList.remove('is-visible');
        removeArtworkButton.disabled = true;
        placeholderButton.textContent = 'Upload Artwork';
        placeholderButton.classList.add('is-visible');
        placeholderButton.disabled = false;
      }
    }

    function computeValidation(){
      if (!State.selectedSides.size) {
        return { ok: false, message: 'Please select at least one print area', reason: 'noSides' };
      }
      const missingUploads = getSelectedSides().filter(side => {
        const upload = State.uploads[side.id];
        return !upload || !upload.fileName || !upload.url;
      });
      if (missingUploads.length) {
        const names = missingUploads.map(side => side?.name || 'Side').join(', ');
        return { ok: false, message: `Please upload artwork for: ${names}`, reason: 'upload' };
      }
      const totalQty = State.rows.reduce((sum, row) => sum + Object.values(row.qtyBySize).reduce((a, b) => a + (parseInt(b, 10) || 0), 0), 0);
      if (!totalQty) {
        return { ok: false, message: 'Please enter quantities for at least one colour and size', reason: 'qty' };
      }
      const method = methodById.get(State.selectedMethodId);
      if (method?.min_order_qty && totalQty < method.min_order_qty) {
        return { ok: false, message: `${method.name} requires a minimum of ${method.min_order_qty} pieces`, reason: 'method_min' };
      }
      const criteria = getActiveCriteria();
      if (criteria?.min_order_qty && totalQty < criteria.min_order_qty) {
        return { ok: false, message: `${criteria.title} minimum order is ${criteria.min_order_qty} pieces`, reason: 'criteria_min' };
      }
      if (criteria?.qty_increment) {
        const increment = Number(criteria.qty_increment);
        if (increment > 0 && totalQty % increment !== 0) {
          return { ok: false, message: `Quantities must be in multiples of ${increment}`, reason: 'criteria_increment' };
        }
      }
      return { ok: true, message: '', reason: null };
    }

    function createCTA(){
      const baseText = refs.addToCart.textContent.trim();
      let resetTimer = null;
      return {
        baseText,
        set(text, disabled, tone = 'default'){
          refs.addToCart.textContent = text;
          refs.addToCart.disabled = disabled;
          refs.addToCart.classList.toggle('qo-btn--alert', tone === 'alert');
          refs.addToCart.classList.toggle('qo-btn--ready', text === baseText);
        },
        refresh(){
          const validation = computeValidation();
          this.set(validation.ok ? baseText : validation.message, !validation.ok, validation.ok ? 'default' : 'alert');
        },
        showMessage(message){
          this.set(message, true, 'alert');
          clearTimeout(resetTimer);
          resetTimer = setTimeout(() => this.refresh(), 3000);
        }
      };
    }

    function refreshValidation(){
      const validation = computeValidation();
      if (refs.postSides) {
        refs.postSides.classList.toggle('is-hidden', validation.reason === 'noSides');
      }
      if (refs.validation) {
        if (validation.ok) {
          refs.validation.textContent = '';
          refs.validation.classList.add('is-hidden');
        } else {
          refs.validation.textContent = validation.message;
          refs.validation.classList.remove('is-hidden');
        }
      }
      CTA.set(validation.ok ? CTA.baseText : validation.message, !validation.ok, validation.ok ? 'default' : 'alert');
      return validation;
    }

    function showToast(message, tone = 'warning'){
      let region = document.getElementById('qo-toast-region');
      if (!region) {
        region = document.createElement('div');
        region.id = 'qo-toast-region';
        region.className = 'qo-toast-region';
        document.body.appendChild(region);
      }
      const item = document.createElement('div');
      item.className = `qo-toast qo-toast--${tone}`;
      item.textContent = message;
      region.appendChild(item);
      requestAnimationFrame(() => item.classList.add('is-visible'));
      setTimeout(() => {
        item.classList.remove('is-visible');
        setTimeout(() => item.remove(), 300);
      }, 3200);
    }

    function openModal({ title, body, onClose, modalClass } = {}){
      const wrap = document.createElement('div');
      wrap.className = 'qo-modal__backdrop';
      wrap.innerHTML = `<div class="qo-modal" role="dialog" aria-modal="true"><header style="display:none;"><div>${title || ''}</div><button aria-label="Close">×</button></header><div class="qo-modal-body"></div></div>`;
      const modal = wrap.querySelector('.qo-modal');
      if (modalClass) modal.classList.add(modalClass);
      const bodyEl = wrap.querySelector('.qo-modal-body');
      if (body instanceof HTMLElement) bodyEl.appendChild(body); else bodyEl.innerHTML = body || '';
      const closeBtn = wrap.querySelector('header button');
      const close = () => { wrap.remove(); onClose && onClose(); };
      closeBtn.addEventListener('click', close);
      wrap.addEventListener('click', e => { if (e.target === wrap) close(); });
      document.body.appendChild(wrap);
      return { close, el: wrap, body: bodyEl };
    }

    function openDecorationMethodsHelp(){
      const tabs = [
        {
          label: 'DTF',
          content: `
            <div class="decoration-content">
              <h2>DTF Printing</h2>
              <p>DTF (Direct-to-Film) printing is ideal for bold logos and branding. It keeps colours crisp across cotton, polyester, and blended fabrics.</p>
              <div class="decoration-image-wrapper"><img alt="DTF printing sample" src="https://cdn.shopify.com/s/files/1/0741/8160/7744/files/dtf-apparel.jpg?v=1749812507"></div>
              <h2>Why choose DTF?</h2>
              <p>Choose DTF when you need strong lines, solid colour blocks, or short runs. It delivers consistent detail with a smooth finish on almost any garment.</p>
              <h2>Artwork Tips</h2>
              <ul class="decoration-list">
                <li><strong>Recommended file types:</strong> SVG, PNG, EPS, AI</li>
                <li><strong>Resolution:</strong> 300 DPI for best results</li>
                <li>Flatten or rasterize text layers before you export</li>
                <li>Use RGB colour mode; our team handles conversion</li>
                <li>Transparent backgrounds work best for PNG uploads</li>
              </ul>
              <h2>How colours are printed</h2>
              <p>Artwork prints in CMYK. Send RGB or Hex colours and we convert them; Pantone callouts help us match brand tones.</p>
              <h2>What makes DTF different?</h2>
              <p>We print your design onto film and heat press it to the garment, resisting cracking or peeling and working on every fabric type.</p>
            </div>
          `
        },
        {
          label: 'DTG',
          content: `
            <div class="decoration-content">
              <h2>DTG Printing</h2>
              <p>DTG (Direct-to-Garment) printing handles gradients, photos, and intricate artwork with a soft finish that feels part of the fabric.</p>
              <div class="decoration-image-wrapper"><img alt="DTG printing sample" src="https://cdn.shopify.com/s/files/1/0693/6425/2915/files/DTG_RINO_FIN_MAI_5414_V2.jpg?v=1725542119"></div>
              <h2>Why choose DTG?</h2>
              <p>Use DTG when you need high detail or full colour imagery. It is perfect for short runs, on-demand drops, and retail quality merch.</p>
              <h2>Artwork Tips</h2>
              <ul class="decoration-list">
                <li><strong>Recommended file types:</strong> SVG, PNG, EPS, AI</li>
                <li><strong>Resolution:</strong> 300 DPI at print size</li>
                <li>Flatten fonts or outline text to prevent surprises</li>
                <li>Design in RGB colour mode; we convert to CMYK in house</li>
                <li>Transparent backgrounds keep the garment fabric showing through</li>
              </ul>
              <h2>How colours are printed</h2>
              <p>DTG uses CMYK inks sprayed directly into the fibres. Pantone notes are welcome so we can tune colours as closely as possible.</p>
              <h2>What makes DTG different?</h2>
              <p>The ink bonds inside the fabric, creating a breathable print that will not crack and is ideal for detailed or photographic artwork.</p>
            </div>
          `
        }
      ];
      const body = document.createElement('div');
      body.className = 'ps_decoration_method_help_wrapper';
      const modalId = `decor-${Date.now().toString(36)}${Math.random().toString(36).slice(2,6)}`;
      const tabIds = tabs.map((_, index) => `${modalId}-tab-${index}`);
      const panelIds = tabs.map((_, index) => `${modalId}-panel-${index}`);
      const tabsHtml = tabs.map((tab, index) => `<button type="button" role="tab" id="${tabIds[index]}" aria-controls="${panelIds[index]}" aria-selected="${index === 0}" tabindex="${index === 0 ? '0' : '-1'}" class="ps_decoration_method_help_tab${index === 0 ? ' active' : ''}" data-tab-index="${index}">${tab.label}</button>`).join('');
      const contentsHtml = tabs.map((tab, index) => `<div class="ps_decoration_method_help_item${index === 0 ? ' is-active' : ''}" role="tabpanel" id="${panelIds[index]}" aria-labelledby="${tabIds[index]}" data-panel-index="${index}"${index === 0 ? '' : ' hidden'}>${tab.content}</div>`).join('');
      body.innerHTML = `
        <div class="ps_decoration_method_help">
          <div class="ps_decoration_method_help_tabs" role="tablist">
            ${tabsHtml}
          </div>
          <div class="ps_decoration_method_help_contents">
            ${contentsHtml}
          </div>
        </div>
      `;
      openModal({
        title: 'Printing Methods Guide',
        body,
        modalClass: 'qo-modal--decor-help'
      });
      const tabButtons = Array.from(body.querySelectorAll('.ps_decoration_method_help_tab'));
      const panels = Array.from(body.querySelectorAll('.ps_decoration_method_help_item'));
      const setActive = (index) => {
        tabButtons.forEach((btn, idx) => {
          const isActive = idx === index;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', String(isActive));
          btn.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach((panel, idx) => {
          const isActive = idx === index;
          panel.classList.toggle('is-active', isActive);
          panel.toggleAttribute('hidden', !isActive);
        });
      };
      tabButtons.forEach((btn, idx) => {
        btn.addEventListener('click', () => setActive(idx));
        btn.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const delta = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (idx + delta + tabButtons.length) % tabButtons.length;
          setActive(nextIndex);
          tabButtons[nextIndex].focus();
        });
      });
      setActive(0);
    }

    function openColorPickerModal(){
      const body = document.createElement('div');
      body.innerHTML = `<div class="qo-grid"></div>`;
      const grid = body.querySelector('.qo-grid');
      const items = COLOR_META.length
        ? COLOR_META.map(c => ({ label: c.label, image: c.image??colorPreview(c.label), hex: c.color }))
        : Object.keys(COLORS).map(name => ({ label: name, image: colorPreview(name), hex: colorFromName(name) }));
      items.forEach(item => {
        const card = document.createElement('div');
        card.className = 'qo-color-card';
        card.innerHTML = item.image
          ? `<img src="${item.image}" alt="${item.label}" style="width:100%;aspect-ratio:4/3;object-fit:cover;border-radius:8px;">`
          : `<div class="qo-color-chip" style="background:${item.hex};"></div>`;
        const caption = document.createElement('div');
        caption.textContent = item.label;
        caption.style.marginTop = '8px';
        caption.style.fontWeight = '700';
        card.appendChild(caption);
        card.addEventListener('click', () => {
          if (!COLORS[item.label]) {
            alert(`No variants exist for colour "${item.label}" on this product.`);
            return;
          }
          if (State.rows.some(row => row.color === item.label)) {
            alert(`${item.label} is already in your order table.`);
            return;
          }
          const qtyBySize = {};
          sizeOrder.forEach(sz => qtyBySize[sz] = 0);
          State.rows.push({ color: item.label, qtyBySize });
          renderRows();
          priceRecalc();
          modal.close();
        });
        grid.appendChild(card);
      });
      const modal = openModal({ title: 'Add Another Colour', body });
    }

    const CTA = createCTA();

    refs.addColor.addEventListener('click', openColorPickerModal);

    refs.addToCart.addEventListener('click', async () => {
      const validation = computeValidation();
      if (!validation.ok) {
        CTA.showMessage(validation.message);
        return;
      }
      const props = { 
        PrintingMethod: methodById.get(State.selectedMethodId)?.name || '',
        Sides: Array.from(State.selectedSides).map(id => sideById.get(id)?.name || id).join(', '),
        Uploads: JSON.stringify(State.uploads)
      };
      getSelectedSides().forEach(side => {
        const upload = State.uploads[side.id];
        if (upload?.fileName) {
          props[`Artwork ${side.name}`] = upload.fileName;
        }
        if (upload?.notes) {
          props[`Notes ${side.name}`] = upload.notes;
        }
      });
      const items = [];
      State.rows.forEach(row => {
        const def = COLORS[row.color];
        if (!def) return;
        def.sizes.forEach(s => {
          const qty = parseInt(row.qtyBySize[s.size] || 0, 10) || 0;
          if (qty) items.push({ id: s.variantId, quantity: qty, properties: props });
        });
      });
      if (!items.length) {
        CTA.showMessage('Please enter quantities for at least one colour and size');
        return;
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        window.dispatchEvent(new CustomEvent('quickorder:added', { detail: { items } }));
      } catch (err) {
        alert(err.message || 'Add to cart failed');
      }
    });

    if (mediaGallery) {
      const viewer = mediaGallery.elements?.viewer || mediaGallery.querySelector('[id^="GalleryViewer"]');
      viewer?.addEventListener('slideChanged', () => {
        attachOverlay();
        drawGuide();
        renderArtwork();
      });
    }

    renderSwatches();
    buildMethods();
    buildSides(true);
    renderBundleTable();
    renderRows();
    renderUploads();
    fetchRecentUploads();
    if (meta.customer_id) {
      fetchCustomerArtworks(meta.customer_id, { silent: true });
    }
    priceRecalc();
    refreshValidation();
    attachOverlay();
  }
})();
